import { WellListFilterModel } from "../../../../models/filter";

/**
 * True when a well list is currently carrying the filter.
 *
 * A list entry with no wells in it names nothing and filters nothing, so it
 * does not count. Shared by both filter thunks and the active-filter tree so
 * every rule that turns on "there is a list" reads it the same way.
 */
export const hasWellListFilter = (
  wellListFilter: Maybe<WellListFilterModel[]>
): boolean => {
  return wellListFilter?.length > 0 && wellListFilter[0]?.value?.length > 0;
};
